/** R2 bucket `images`, key `partners/<partner>/<path>`. */
const PARTNER_MEDIA_BASE = "https://media.stippl.io/partners";

export const partnerAsset = (partner: string, path: string): string => `${PARTNER_MEDIA_BASE}/${partner}/${path}`;
